export const msalConfig = {
  auth: {
    clientId: `${process.env.REACT_APP_CLIENTID}`, //application ID
    authority:
      "https://login.microsoftonline.com/632485c9-5235-41c8-8c29-c0819fe3f718", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    //redirectUri: "http://localhost:3000",
    redirectUri: `${process.env.REACT_APP_REDIRECT_URI}`,
  },

  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.

export const loginRequest = {
  scopes: ["User.Read", process.env.REACT_APP_SCOPE],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.

export const protectedResources = {
  graphMe: {
    endpoint: "https://graph.microsoft.com/v1.0/me",

    scopes: ["User.Read", "User.ReadAll"],
  },

  authAPI: {
    scopes: [`${process.env.REACT_APP_SCOPE}`],
  },
};
